import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { CompleteLicense } from '@/interfaces/dashboard/licenses';
import { DashboardService } from '@/services/dashboard/dashboard.service';
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
} from 'swiper/core';
import { CommonService } from '@/services/common/common.service';

SwiperCore.use([
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
]);
@Component({
  selector: 'app-license-status',
  templateUrl: './license-status.component.html',
  styleUrls: ['./license-status.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LicenseStatusComponent implements OnInit {
  @Input() userMdmid: string = '';

  licensesData: CompleteLicense[] = [];
  licenseDetail: Partial<CompleteLicense> = {};
  zonesRows: Array<number[]> = [];
  showDocumentsValidity: boolean = false;

  licensesLoading: boolean = true;
  licensesError: string = '';
  infractionsLoading: boolean = true;
  infractionsError: string = '';

  constructor(
    private dashboardService: DashboardService,
    private commonService: CommonService,
  ) {
  }

  ngOnInit(): void {
    this.getLicensesData();
  }

  getZonesRows() {
    this.licensesData.forEach((license) => {
      const zonesRowsByAsset: number[] = [];
      license.equipments.forEach((vehicle) => {
        const zonesLength = vehicle.conductionZones.length;
        zonesRowsByAsset.push(Math.ceil(zonesLength / 2));
      });
      this.zonesRows.push(zonesRowsByAsset);
    });
  }

  onClickDocumentsValidity(licenseIndex: number) {
    this.licenseDetail = this.licensesData[licenseIndex];
    this.showDocumentsValidity = true;
  }

  controlledSwiper: any;
  setControlledSwiper(swiper: any) {
    this.controlledSwiper = swiper;
  }

  getLicensesData() {
    this.commonService.getLicenseByUser(this.userMdmid)
      .subscribe({
        next: (data) => {
          this.licensesData = data.sort((a, b) => {
            if (a.asset.name > b.asset.name) {
              return 1;
            }
            if (a.asset.name < b.asset.name) {
              return -1;
            }
            return 0;
          });

          this.getZonesRows();
          this.licensesLoading = false;
        },
        error: () => {
          this.licensesData = [];
          this.licensesError = 'Ha ocurrido un error al intentar obtener la información asociada a licencias.';
          this.licensesLoading = false;
        },
      });
  }
}
